export class Postulante {
    id: Number;
    name: string;
    email: string;
    phone: string;
    interes: string;
    turno: string;
    promotion: boolean;
    favoritos: Favorito[]
}

class Favorito{
    id: Number;
    nombre: string;
    postulante_id: Number;
}